module.exports = __webpack_public_path__ + "img/ser-img1.1902d1bf.png";